import {geoCentroid} from "../../../_snowpack/pkg/d3-geo.js";
import React, {useCallback, useEffect, useRef, useState} from "../../../_snowpack/pkg/react.js";
import {OverlayTrigger, Popover} from "../../../_snowpack/pkg/react-bootstrap.js";
import {
  ComposableMap,
  Geographies,
  Geography,
  Marker
} from "../../../_snowpack/pkg/react-simple-maps.js";
import "../../App.js";
import BolinasA from "../../Assets/bolinas_1.jpeg";
import BolinasB from "../../Assets/bolinas_2.jpeg";
import BolinasC from "../../Assets/bolinas_3.jpg";
import CampusA from "../../Assets/campus.jpg";
import CampusB from "../../Assets/campus_1.jpg";
import CentralParkA from "../../Assets/central_park_1.jpg";
import CentralParkB from "../../Assets/central_park_2.jpg";
import ChinaTown from "../../Assets/chinatown.jpg";
import DeerPark from "../../Assets/deer_park.jpg";
import EastMeadow from "../../Assets/east_meadow.jpg";
import Kanye from "../../Assets/kanye_west.jpg";
import Legos from "../../Assets/legos_new_york.jpg";
import PublicMarketCenter from "../../Assets/public_market_center.jpg";
import Roosevelt from "../../Assets/roosevelt.jpg";
import SeattleB from "../../Assets/seattle_2.jpg";
import SeattleC from "../../Assets/seattle_3.jpg";
import ThroggsNeck from "../../Assets/throgg_neck.jpg";
import Waves from "../../Assets/waves.jpg";
import ImageCard from "../../Components/ImageCard/ImageCard.js";
import SpotifyPlaylist from "../../Components/SpotifyPlaylist/SpotifyPlaylist.js";
import styles from "./AboutMePage.module.css";
const newYorkImageQueue = [
  {
    image: CentralParkA,
    description: "Manhattan, New York, USA"
  },
  {
    image: CentralParkB,
    description: "Manhattan, New York, USA"
  },
  {
    image: DeerPark,
    description: "Deer Park, New York, USA"
  },
  {
    image: EastMeadow,
    description: "East Meadow, New York, USA"
  },
  {
    image: Legos,
    description: "Manhattan, New York, USA"
  },
  {
    image: Roosevelt,
    description: "Roosevelt Island, New York, USA"
  },
  {
    image: Waves,
    description: "New York City, New York, USA"
  },
  {
    image: ThroggsNeck,
    description: "Throggs Neck Bridge, New York City, New York, USA"
  }
];
const washingtonImageQueue = [
  {
    image: SeattleB,
    description: "Seattle, Washington, USA"
  },
  {
    image: SeattleC,
    description: "Seattle, Washington, USA"
  },
  {
    image: PublicMarketCenter,
    description: "Seattle, Washington, USA"
  }
];
const caliImageQueue = [
  {
    image: BolinasA,
    description: "Bolinas, California, USA"
  },
  {
    image: BolinasB,
    description: "Bolinas, California, USA"
  },
  {
    image: BolinasC,
    description: "Bolinas, California, USA"
  },
  {
    image: ChinaTown,
    description: "San Francisco, California, USA"
  },
  {
    image: Kanye,
    description: "San Francisco, California, USA"
  },
  {
    image: CampusA,
    description: "Oakland, California, USA"
  },
  {
    image: CampusB,
    description: "Oakland, California, USA"
  }
];
const geoUrl = "https://cdn.jsdelivr.net/npm/us-atlas@3/states-10m.json";
const spotify_client_id = "259dfd43bc824ed2b7487be95ac5b590";
const spotify_client_secret = "b4d72c0e1b5e4a888dabbd9ec0a17571";
const imageLinker = [
  {
    state: "New York",
    imageList: newYorkImageQueue
  },
  {
    state: "California",
    imageList: caliImageQueue
  },
  {
    state: "Washington",
    imageList: washingtonImageQueue
  }
];
const AboutMePage = () => {
  const [token, setToken] = useState(null);
  const [songUri, setSongUri] = useState(null);
  const [embedController, setEmbedController] = useState(null);
  const getToken = useCallback(async () => {
    const authOptions = {
      method: "POST",
      headers: {
        Authorization: "Basic " + btoa(`${spotify_client_id}:${spotify_client_secret}`),
        "Content-Type": "application/x-www-form-urlencoded"
      },
      body: "grant_type=client_credentials"
    };
    try {
      const response = await fetch("https://accounts.spotify.com/api/token", authOptions);
      const data = await response.json();
      if (response.ok) {
        setToken(data.access_token);
        setTimeout(getToken, 50 * 60 * 1e3);
      } else {
        console.error("Error fetching the token:", data);
      }
    } catch (error) {
      console.error("Error fetching the token:", error);
    }
  }, []);
  useEffect(() => {
    getToken();
  }, [getToken]);
  const handleSongUri = (s) => {
    setSongUri(s);
  };
  const iframeRef = useRef(null);
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://open.spotify.com/embed-podcast/iframe-api/v1";
    script.async = true;
    document.body.appendChild(script);
    script.onload = () => {
      const element = document.getElementById("embed-iframe");
      if (element) {
        window.onSpotifyIframeApiReady = (IFrameAPI) => {
          const options = {
            uri: songUri || ""
          };
          const callback = (controller) => {
            setEmbedController(controller);
            if (songUri) {
              controller.loadUri(songUri);
            }
          };
          IFrameAPI.createController(element, options, callback);
        };
      }
    };
    return () => {
      document.body.removeChild(script);
    };
  }, [songUri]);
  useEffect(() => {
    if (embedController && songUri) {
      embedController.loadUri(songUri);
      embedController.play();
    }
  }, [embedController, songUri]);
  const getInitials = (name) => {
    var states = [
      ["Arizona", "AZ"],
      ["Alabama", "AL"],
      ["Arkansas", "AR"],
      ["California", "CA"],
      ["Colorado", "CO"],
      ["Connecticut", "CT"],
      ["Delaware", "DE"],
      ["Florida", "FL"],
      ["Georgia", "GA"],
      ["Hawaii", "HI"],
      ["Idaho", "ID"],
      ["Illinois", "IL"],
      ["Indiana", "IN"],
      ["Iowa", "IA"],
      ["Kansas", "KS"],
      ["Kentucky", "KY"],
      ["Louisiana", "LA"],
      ["Maine", "ME"],
      ["Maryland", "MD"],
      ["Massachusetts", "MA"],
      ["Michigan", "MI"],
      ["Minnesota", "MN"],
      ["Mississippi", "MS"],
      ["Missouri", "MO"],
      ["Montana", "MT"],
      ["Nebraska", "NE"],
      ["Nevada", "NV"],
      ["New Hampshire", "NH"],
      ["New Jersey", "NJ"],
      ["New Mexico", "NM"],
      ["New York", "NY"],
      ["North Carolina", "NC"],
      ["North Dakota", "ND"],
      ["Ohio", "OH"],
      ["Oklahoma", "OK"],
      ["Oregon", "OR"],
      ["Pennsylvania", "PA"],
      ["Rhode Island", "RI"],
      ["South Carolina", "SC"],
      ["South Dakota", "SD"],
      ["Tennessee", "TN"],
      ["Texas", "TX"],
      ["Utah", "UT"],
      ["Vermont", "VT"],
      ["Virginia", "VA"],
      ["Washington", "WA"],
      ["West Virginia", "WV"],
      ["Wisconsin", "WI"],
      ["Wyoming", "WY"]
    ];
    for (let i = 0; i < states.length; i++) {
      if (states[i][0] === name) {
        return states[i][1];
      }
    }
    return "";
  };
  const generateImages = (stateName) => {
    const stateImages = imageLinker.find((item) => item.state === stateName)?.imageList;
    if (stateImages && stateImages.length > 0) {
      return stateImages.map((image, index) => /* @__PURE__ */ React.createElement(ImageCard, {
        key: index,
        image: image.image,
        description: image.description
      }));
    }
    return null;
  };
  const getLocationsVisited = (geo) => {
    const visitedStates = ["New York", "California", "Washington"];
    return visitedStates.includes(geo);
  };
  const popover = (stateName) => {
    if (!getLocationsVisited(stateName)) {
      return /* @__PURE__ */ React.createElement("div", null);
    }
    return /* @__PURE__ */ React.createElement(Popover, {
      className: styles.popover,
      placement: "bottom",
      id: "popover-basic"
    }, /* @__PURE__ */ React.createElement(Popover.Header, {
      as: "h3",
      className: styles.popoverHeader
    }, "Places I've been"), /* @__PURE__ */ React.createElement(Popover.Body, {
      className: styles.popoverBody
    }, generateImages(stateName)));
  };
  return /* @__PURE__ */ React.createElement("div", {
    className: styles.pageContainer
  }, /* @__PURE__ */ React.createElement("div", {
    className: styles.spotifyTextContainer
  }, /* @__PURE__ */ React.createElement("p", null, " Take a look at some of my favorite tracks! If you have Spotify Premium, press play for the full song."), /* @__PURE__ */ React.createElement("p", null, "Start by picking a genre. ")), /* @__PURE__ */ React.createElement("div", {
    className: styles.spotifyContentContainer
  }, /* @__PURE__ */ React.createElement("div", {
    className: styles.iFrameContainer
  }, /* @__PURE__ */ React.createElement("div", {
    id: "embed-iframe",
    ref: iframeRef
  })), /* @__PURE__ */ React.createElement("div", {
    className: styles.playlistContainer
  }, token ? /* @__PURE__ */ React.createElement(SpotifyPlaylist, {
    token,
    songURI: songUri,
    handler: handleSongUri
  }) : /* @__PURE__ */ React.createElement("p", {
    style: {color: "white"}
  }, "Loading..."))), /* @__PURE__ */ React.createElement("div", {
    className: styles.aboutMeContainer
  }, /* @__PURE__ */ React.createElement("div", {
    className: styles.leftBoxContainer
  }, /* @__PURE__ */ React.createElement("h1", {
    className: styles.aboutMeHeader
  }, "Who Am I?"), /* @__PURE__ */ React.createElement("p", {
    className: styles.aboutMeText
  }, "I am currently a sophomore at Northeastern University, pursuing a BS in Computer Science. My college experience has given me the opportunity to travel around the United States, visiting amazing places like the Bay Area in California and Seattle, Washington. In my free time, I love listening to music, exercising, and reading comic books. My favorite music genres include hip hop, rock, and almost anything from the 2000s. I enjoy various forms of exercise, such as boxing, basketball, and weight lifting. As for comics, my favorite series since childhood has been Big Nate.")), /* @__PURE__ */ React.createElement("div", {
    className: styles.rightBoxContainer
  }, /* @__PURE__ */ React.createElement("h1", {
    className: styles.aboutMeHeader
  }, "What Does That Mean For You?"), /* @__PURE__ */ React.createElement("p", {
    className: styles.aboutMeText
  }, "As a developer, I want to use my skills for creating digital business and education solutions that boost our communities. Whether it’s a website for an up-and-coming bakery or an AI-powered chatbot that provides seamless customer support, I want to lend my expertise to help you worry about what’s important: your success!"))), /* @__PURE__ */ React.createElement("div", {
    className: styles.skillsContainer
  }, /* @__PURE__ */ React.createElement("h1", {
    className: styles.skillsHeader
  }, "The Skills I Offer For You and Your Business: "), /* @__PURE__ */ React.createElement("div", {
    className: styles.skillsList
  }, /* @__PURE__ */ React.createElement("div", {
    className: styles.skillsListItem
  }, /* @__PURE__ */ React.createElement("svg", {
    width: "100px",
    height: "100px",
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M31.885 16c-8.124 0-7.617 3.523-7.617 3.523l.01 3.65h7.752v1.095H21.197S16 23.678 16 31.876c0 8.196 4.537 7.906 4.537 7.906h2.708v-3.804s-.146-4.537 4.465-4.537h7.688s4.32.07 4.32-4.175v-7.019S40.374 16 31.885 16zm-4.275 2.454c.771 0 1.395.624 1.395 1.395s-.624 1.395-1.395 1.395a1.393 1.393 0 0 1-1.395-1.395c0-.771.624-1.395 1.395-1.395z",
    fill: "url(#a)"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M32.115 47.833c8.124 0 7.617-3.523 7.617-3.523l-.01-3.65H31.97v-1.095h10.832S48 40.155 48 31.958c0-8.197-4.537-7.906-4.537-7.906h-2.708v3.803s.146 4.537-4.465 4.537h-7.688s-4.32-.07-4.32 4.175v7.019s-.656 4.247 7.833 4.247zm4.275-2.454a1.393 1.393 0 0 1-1.395-1.395c0-.77.624-1.394 1.395-1.394s1.395.623 1.395 1.394c0 .772-.624 1.395-1.395 1.395z",
    fill: "url(#b)"
  }), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("linearGradient", {
    id: "a",
    x1: "19.075",
    y1: "18.782",
    x2: "34.898",
    y2: "34.658",
    gradientUnits: "userSpaceOnUse"
  }, /* @__PURE__ */ React.createElement("stop", {
    "stop-color": "#387EB8"
  }), /* @__PURE__ */ React.createElement("stop", {
    offset: "1",
    "stop-color": "#366994"
  })), /* @__PURE__ */ React.createElement("linearGradient", {
    id: "b",
    x1: "28.809",
    y1: "28.882",
    x2: "45.803",
    y2: "45.163",
    gradientUnits: "userSpaceOnUse"
  }, /* @__PURE__ */ React.createElement("stop", {
    "stop-color": "#FFE052"
  }), /* @__PURE__ */ React.createElement("stop", {
    offset: "1",
    "stop-color": "#FFC331"
  })))), /* @__PURE__ */ React.createElement("div", {
    className: styles.skillsListItemText
  }, /* @__PURE__ */ React.createElement("h2", {
    className: styles.skillsListText
  }, "Python"), /* @__PURE__ */ React.createElement("text", {
    className: styles.skillsListText,
    style: {fontSize: 20}
  }, "Experienced in machine learning, graphing, and gaming libraries (Ex. pygame, numpy, matplotlib)."))), /* @__PURE__ */ React.createElement("div", {
    className: styles.skillsListItem
  }, /* @__PURE__ */ React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: "100",
    height: "100",
    viewBox: "0 0 50 50",
    fill: "red"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M 28.1875 0 C 30.9375 6.363281 18.328125 10.292969 17.15625 15.59375 C 16.082031 20.464844 24.648438 26.125 24.65625 26.125 C 23.355469 24.109375 22.398438 22.449219 21.09375 19.3125 C 18.886719 14.007813 34.535156 9.207031 28.1875 0 Z M 36.5625 8.8125 C 36.5625 8.8125 25.5 9.523438 24.9375 16.59375 C 24.6875 19.742188 27.847656 21.398438 27.9375 23.6875 C 28.011719 25.558594 26.0625 27.125 26.0625 27.125 C 26.0625 27.125 29.609375 26.449219 30.71875 23.59375 C 31.949219 20.425781 28.320313 18.285156 28.6875 15.75 C 29.039063 13.324219 36.5625 8.8125 36.5625 8.8125 Z M 19.1875 25.15625 C 19.1875 25.15625 9.0625 25.011719 9.0625 27.875 C 9.0625 30.867188 22.316406 31.089844 31.78125 29.25 C 31.78125 29.25 34.296875 27.519531 34.96875 26.875 C 28.765625 28.140625 14.625 28.28125 14.625 27.1875 C 14.625 26.179688 19.1875 25.15625 19.1875 25.15625 Z M 38.65625 25.15625 C 37.664063 25.234375 36.59375 25.617188 35.625 26.3125 C 37.90625 25.820313 39.84375 27.234375 39.84375 28.84375 C 39.84375 32.46875 34.59375 35.875 34.59375 35.875 C 34.59375 35.875 42.71875 34.953125 42.71875 29 C 42.71875 26.296875 40.839844 24.984375 38.65625 25.15625 Z M 16.75 30.71875 C 15.195313 30.71875 12.875 31.9375 12.875 33.09375 C 12.875 35.417969 24.5625 37.207031 33.21875 33.8125 L 30.21875 31.96875 C 24.351563 33.847656 13.546875 33.234375 16.75 30.71875 Z M 18.1875 35.9375 C 16.058594 35.9375 14.65625 37.222656 14.65625 38.1875 C 14.65625 41.171875 27.371094 41.472656 32.40625 38.4375 L 29.21875 36.40625 C 25.457031 37.996094 16.015625 38.238281 18.1875 35.9375 Z M 11.09375 38.625 C 7.625 38.554688 5.375 40.113281 5.375 41.40625 C 5.375 48.28125 40.875 47.964844 40.875 40.9375 C 40.875 39.769531 39.527344 39.203125 39.03125 38.9375 C 41.933594 45.65625 9.96875 45.121094 9.96875 41.15625 C 9.96875 40.253906 12.320313 39.390625 14.5 39.8125 L 12.65625 38.75 C 12.113281 38.667969 11.589844 38.636719 11.09375 38.625 Z M 44.625 43.25 C 39.226563 48.367188 25.546875 50.222656 11.78125 47.0625 C 25.542969 52.695313 44.558594 49.535156 44.625 43.25 Z"
  })), /* @__PURE__ */ React.createElement("div", {
    className: styles.skillsListItemText
  }, /* @__PURE__ */ React.createElement("h2", {
    className: styles.skillsListText
  }, "Java/Kotlin"), /* @__PURE__ */ React.createElement("text", {
    className: styles.skillsListText,
    style: {fontSize: 20}
  }, "Experienced in JUnit testing, object-oriented, and test-driven programming."))), /* @__PURE__ */ React.createElement("div", {
    className: styles.skillsListItem
  }, /* @__PURE__ */ React.createElement("svg", {
    viewBox: "0 0 34 32",
    fill: "blue",
    height: "100px",
    width: "100px"
  }, /* @__PURE__ */ React.createElement("path", {
    fill: "#61dbfb",
    d: "M19.314 15.987a2.392 2.392 0 11-4.784 0 2.392 2.392 0 014.784 0z"
  }), /* @__PURE__ */ React.createElement("path", {
    fill: "#61dbfb",
    d: "M16.922 24.783c1.878 1.826 3.729 2.906 5.221 2.906.489 0 .952-.103 1.337-.334 1.337-.772 1.826-2.701 1.363-5.453-.077-.489-.18-.977-.309-1.492.514-.154.977-.309 1.44-.463 2.598-1.003 4.038-2.392 4.038-3.909 0-1.543-1.44-2.932-4.038-3.909-.463-.18-.926-.334-1.44-.463.129-.514.232-1.003.309-1.492.437-2.803-.051-4.758-1.389-5.53-.386-.231-.849-.334-1.337-.334-1.466 0-3.344 1.08-5.221 2.906-1.852-1.826-3.704-2.906-5.195-2.906-.489 0-.952.103-1.337.334-1.337.772-1.826 2.701-1.363 5.453.077.489.18.977.309 1.492-.514.154-.977.309-1.44.463-2.598 1.003-4.038 2.392-4.038 3.909 0 1.543 1.44 2.932 4.038 3.909.463.18.926.334 1.44.463a16.882 16.882 0 00-.309 1.492c-.437 2.752.051 4.707 1.363 5.453.386.232.849.334 1.337.334 1.492.051 3.344-1.029 5.221-2.829zm-1.441-3.472c.463.026.952.026 1.44.026s.977 0 1.44-.026a24.523 24.523 0 01-1.44 1.723 24.252 24.252 0 01-1.44-1.723zm-3.189-2.649c.257.437.489.849.772 1.26a27.786 27.786 0 01-2.263-.386c.232-.694.489-1.415.797-2.135.206.411.437.849.694 1.26zM10.8 12.463c.72-.154 1.466-.283 2.263-.386-.257.412-.514.823-.772 1.26s-.489.849-.694 1.286a17.109 17.109 0 01-.797-2.161zm1.415 3.524c.334-.694.694-1.389 1.106-2.083.386-.669.823-1.337 1.26-2.006a35.293 35.293 0 014.682 0c.463.669.874 1.337 1.26 2.006.412.694.772 1.389 1.106 2.083a26.922 26.922 0 01-1.106 2.083c-.386.669-.823 1.337-1.26 2.006a35.293 35.293 0 01-4.682 0 28.695 28.695 0 01-1.26-2.006 27.106 27.106 0 01-1.106-2.083zm10.057-1.389l-.694-1.286c-.257-.437-.489-.849-.772-1.26.797.103 1.543.232 2.263.386-.231.72-.489 1.44-.797 2.161zm0 2.778c.309.72.566 1.44.797 2.135-.72.154-1.466.283-2.263.386.257-.412.514-.823.772-1.26.232-.386.463-.823.694-1.26zm.591 8.925c-.206.129-.463.18-.746.18-1.26 0-2.829-1.029-4.372-2.572a26.868 26.868 0 002.186-2.701 23.619 23.619 0 003.447-.54c.129.463.206.926.283 1.389.36 2.186.077 3.755-.797 4.244zm1.338-13.555c2.881.823 4.604 2.083 4.604 3.241 0 1.003-1.183 2.006-3.266 2.804-.412.154-.874.309-1.337.437a27.01 27.01 0 00-1.26-3.241c.514-1.106.952-2.186 1.26-3.241zm-2.058-7.253c.283 0 .514.051.746.18.849.489 1.157 2.032.797 4.244-.077.437-.18.9-.283 1.389a33.072 33.072 0 00-3.447-.54 23.774 23.774 0 00-2.186-2.701c1.543-1.518 3.112-2.572 4.372-2.572zm-3.781 5.17c-.463-.026-.952-.026-1.44-.026s-.977 0-1.44.026c.463-.617.952-1.183 1.44-1.723.489.54.977 1.132 1.44 1.723zm-7.382-4.99c.206-.129.463-.18.746-.18 1.26 0 2.829 1.029 4.372 2.572a26.756 26.756 0 00-2.186 2.701 23.619 23.619 0 00-3.447.54c-.129-.463-.206-.926-.283-1.389-.36-2.186-.077-3.729.797-4.244zM9.643 19.228c-2.881-.823-4.604-2.083-4.604-3.241 0-1.003 1.183-2.006 3.266-2.803.412-.154.874-.309 1.337-.437a27.01 27.01 0 001.26 3.241c-.514 1.106-.952 2.212-1.26 3.241zm.54 2.829c.077-.437.18-.9.283-1.389 1.08.232 2.238.412 3.447.54a23.774 23.774 0 002.186 2.701c-1.543 1.517-3.112 2.572-4.372 2.572-.283 0-.514-.051-.746-.18-.875-.489-1.157-2.058-.797-4.244z"
  })), /* @__PURE__ */ React.createElement("div", {
    className: styles.skillsListItemText
  }, /* @__PURE__ */ React.createElement("h2", {
    className: styles.skillsListText
  }, "ReactJS"), /* @__PURE__ */ React.createElement("text", {
    className: styles.skillsListText,
    style: {fontSize: 20}
  }, "Worked with Typescript and React Native to produce mobile and web applications."))), /* @__PURE__ */ React.createElement("div", {
    className: styles.skillsListItem
  }, /* @__PURE__ */ React.createElement("svg", {
    fill: "gray",
    height: "100px",
    width: "100px",
    version: "1.1",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 490 490"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M490,85.776C490,30.065,363.774,0,245,0C126.227,0,0,30.065,0,85.776v318.447C0,459.935,126.227,490,245,490  c118.774,0,245-30.065,245-85.777V85.776z M20.851,220.756C61.53,253.097,155.38,270.218,245,270.218  c89.621,0,183.471-17.122,224.149-49.462v73.572c0,30.646-95.855,64.926-224.149,64.926c-128.292,0-224.149-34.28-224.149-64.926  V220.756z M245,249.367c-128.292,0-224.149-34.28-224.149-64.935V122.1C61.53,154.442,155.38,171.563,245,171.563  c89.621,0,183.471-17.121,224.149-49.462v62.331C469.149,215.087,373.294,249.367,245,249.367z M245,20.851  c128.294,0,224.149,34.28,224.149,64.925c0,30.656-95.855,64.935-224.149,64.935c-128.292,0-224.149-34.279-224.149-64.935  C20.851,55.131,116.708,20.851,245,20.851z M245,469.149c-128.292,0-224.149-34.28-224.149-64.926v-73.577  C61.53,362.983,155.38,380.104,245,380.104c89.621,0,183.471-17.122,224.149-49.458v73.577  C469.149,434.869,373.294,469.149,245,469.149z"
  })), /* @__PURE__ */ React.createElement("div", {
    className: styles.skillslistItemText
  }, /* @__PURE__ */ React.createElement("h2", {
    className: styles.skillsListText
  }, "Full-Stack Web & App Development"), /* @__PURE__ */ React.createElement("text", {
    className: styles.skillsListText,
    style: {fontSize: 20}
  }, "Worked both in front-end (CSS, React Native) and back-end (Python, Java), ensuring quality service on both ends."))))), /* @__PURE__ */ React.createElement("div", {
    className: styles.mapContainer
  }, /* @__PURE__ */ React.createElement("h1", {
    className: styles.mapHeading
  }, "Click the states marked with an X and check out some places I've been!"), /* @__PURE__ */ React.createElement(ComposableMap, {
    className: styles.map,
    fill: "white",
    stroke: "black",
    strokeWidth: 1,
    overflow: "hidden",
    projectionConfig: {
      scale: 500,
      center: [-100, 20],
      rotate: [-11, 0, 0]
    },
    width: 800
  }, /* @__PURE__ */ React.createElement(Geographies, {
    geography: geoUrl,
    viewBox: "0 0 800 400",
    style: {overflowX: "hidden", overflowY: "hidden"}
  }, ({geographies}) => geographies.map((geo) => /* @__PURE__ */ React.createElement(React.Fragment, {
    key: geo.rsmKey
  }, /* @__PURE__ */ React.createElement(OverlayTrigger, {
    trigger: "click",
    placement: "bottom",
    rootClose: true,
    overlay: popover(geo.properties.name)
  }, getInitials(geo.properties.name) !== "" ? /* @__PURE__ */ React.createElement(Geography, {
    geography: geo,
    className: styles.state,
    style: {
      default: {fill: "white"},
      hover: {fill: "gray"}
    }
  }) : /* @__PURE__ */ React.createElement("div", null)), /* @__PURE__ */ React.createElement(Marker, {
    coordinates: geoCentroid(geo)
  }, /* @__PURE__ */ React.createElement("text", {
    className: styles.stateText,
    dy: "2"
  }, getInitials(geo.properties.name))), getLocationsVisited(geo.properties.name) ? /* @__PURE__ */ React.createElement(Marker, {
    coordinates: geoCentroid(geo)
  }, /* @__PURE__ */ React.createElement("text", {
    className: styles.marker,
    dy: "7"
  }, "X")) : null))))));
};
export default AboutMePage;
